import React from 'react';
import { useTranslation } from 'react-i18next';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import Spacing from '../Spacing';
import Post from '../Post';
import Sidebar from '../Sidebar';
import { pageTitle } from '../../helpers/PageTitle';
import SEO from '../SEO';

export default function BlogDetailsDializa() {
  const { t } = useTranslation();

  const relatedBlog = [
    {
      title: t('blog.blog2Title'),
      thumbUrl: '/images/blog/blog_2.jpg',
      date: t('blog.blog2Date'),
      btnText: t('blog.readMore'),
      href: '/blog/diabeti',
    },
    {
      title: t('blog.blog3Title'),
      thumbUrl: '/images/blog/blog_3.jpg',
      date: t('blog.blog3Date'),
      btnText: t('blog.readMore'),
      href: '/blog/kanceri',
    },
  ];

  pageTitle('Dializa Peritoneale | Blog | Incomed');

  return (
    <>
      <SEO title="Dializa Peritoneale" description="Gjithçka që duhet të dini rreth dializes peritoneale - metodës moderne të trajtimit të sëmundjes renale." url="/blog/dializa-peritoneale" />
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={t('blog.blog1Title')} />
      </Section>
      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            <div className="cs_blog_details_date">
              {t('blog.blog1Date')} | Incomed
            </div>
          </div>

        </div>
        <Spacing md="55" />
        <div style={{ maxWidth: '900px' }}>
          <img
            src="/images/blog/blog_1.jpeg"
            alt="Dializa Peritoneale"
            className="w-100 cs_radius_20"
          />
        </div>
        <Spacing md="90" lg="50" />
        <div className="row">
          <div className="col-lg-10">
            <div className="cs_blog_details">
              <h2>{t('blog.blog1Title')}</h2>
              <p>
                {t('blog.blog1Intro')}
              </p>

              <h3>{t('blog.blog1Section1Title')}</h3>
              <p>
                {t('blog.blog1Section1Content')}
              </p>

              <blockquote>
                <p>
                  "{t('blog.blog1Quote')}"
                </p>
              </blockquote>

              <h3>{t('blog.blog1Section2Title')}</h3>
              <p>
                {t('blog.blog1Section2Content')}
              </p>
            </div>
          </div>
        </div>
        <Spacing md="135" lg="100" />
        <h2 className="mb-0 cs_fs_40 cs_medium">{t('blog.relatedArticles')}</h2>
        <Spacing md="57" />
        <div className="row cs_gap_y_40">
          {relatedBlog?.map((item, index) => (
            <div className="col-xl-6 col-md-6" key={index}>
              <Post {...item} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
